const PaymentsConstants = {

  freightUnit: {
    per_trip: 1,
    per_ton: 2,
    per_kg: 3,
    per_cft: 4,
    per_package: 5,
    per_case: 6,
    per_box: 7,
    per_km: 8,
    percentage: 9,
  },

  indentStatus: {
    DISPATCHED: 6,
    CANCELLED: 8,
    DELIVERED: 7,
  },

};

module.exports = PaymentsConstants;
